"use strict";
import { Trans } from "react-i18next";
import { Flex, Text } from "ui/src";
import { OnchainItemSectionName } from "components/lists/OnchainItemList/types";
import { SectionHeader } from "components/lists/SectionHeader";
export function NoResultsFound({ searchFilter }) {
  return <Flex>
      <SectionHeader sectionKey={OnchainItemSectionName.SearchResults} />
      <Text color="$neutral3" mt="$spacing16" mx="$spacing20" textAlign="center" variant="subheading2">
        <Trans
    components={{ highlight: <Text color="$neutral1" variant="subheading2" /> }}
    i18nKey="tokens.selector.search.empty"
    values={{ searchText: searchFilter }}
  />
      </Text>
    </Flex>;
}
